import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
